export const HARDCODED_PRESET_OPTIONS = [
  { id: 'DRAFT', name: 'Draft' },
  { id: 'TEST', name: 'Test' },
  { id: 'PROD_STANDARD', name: 'Prod Standard' },
  { id: 'PROD_LARGE', name: 'Prod Large' },
  { id: 'NONE', name: 'None' },
];

export const errorMessage = 'Value must be greater than or equal to 0';

export const PLANNER_INFO_POPOVER = {
  target_objective: {
    title: 'Target makespan value.',
  },
  max_computation_time: {
    title: 'Max computation time allowed for the planner, in seconds.',
  },
  max_dead_time: {
    title: 'Max dead time allowed between tasks with a transport between them.',
  },
  preset: {
    title:
      'The plan CLI has a number of presets that can be used to quickly adjust the behaviour of the planner to suit different user needs. The available presets are:',
    copy: '- DRAFT: To be used when it is not important if the plan is accurate or feasible. A plan generated with this preset does not guarantee that the workflow is actually possible to run in the real world<br/><br/>- TEST: The planner will try to find a plan quickly, but it may not be optimal.<br/><br/>- PROD STANDARD: A preset with fairly standard settings. This is useful for making sure that the planner is using the recommended settings.<br/><br/> - PROD LARGE: A preset with settings that are more suitable for large workflows. This preset is useful when the workflow is large and the planner is taking a long time to find a plan.',
  },
  round_robin_load_balancing: {
    title:
      'Where there are equidistant instruments (instruments that take the same time to transport to), maestro uses round robin to assign instruments to those tasks.',
  },
};
